import {useBackgroundStyleConfigs} from 'hooks/useBackgroundStyleConfigs';

import {SubcomponentsLinkComponent, TypoComponentsSeoTags} from 'lib/api/strapi';

import {Box, Typography} from 'components/basic-components';
import MarkdownContent from 'components/basic-components/MarkdownContent';
import {withErrorBoundary} from 'components/error/ErrorBoundary';

import {SeoLink} from './SeoLink';
import styles from './seotags.module.scss';

const SeoTags = ({title, description, titleLevel, seoLinks}: TypoComponentsSeoTags) => {
  const {textColor} = useBackgroundStyleConfigs();
  return (
    <Box sx={{padding: '50px 0', color: textColor}}>
      <Typography className={styles.seotagtitle} component={titleLevel} variant="h2">
        {title}
      </Typography>
      <MarkdownContent className={styles.description} content={description} />
      <Box className={styles.seoLinkWrapper}>
        {seoLinks.map((link: SubcomponentsLinkComponent) => (
          <SeoLink key={link.id} {...link} />
        ))}
      </Box>
    </Box>
  );
};
export default withErrorBoundary(SeoTags, ' SeoTags');
